
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ModalC1 from './SwitchModals/ModalC1.vue';
import ModalC2 from './SwitchModals/ModalC2.vue';
import ModalC3 from './SwitchModals/ModalC3.vue';
import ModalC4 from './SwitchModals/ModalC4.vue';
import ModalC5 from './SwitchModals/ModalC5.vue';
import ModalC6 from './SwitchModals/ModalC6.vue';
import ModalC7 from './SwitchModals/ModalC7.vue';
import ModalC8 from './SwitchModals/ModalC8.vue';
import ModalC9 from './SwitchModals/ModalC9.vue';
import ModalC10 from './SwitchModals/ModalC10.vue';
import ModalC11 from './SwitchModals/ModalC11.vue';
import ModalC12 from './SwitchModals/ModalC12.vue';

@Component({
  name: 'EventModal',
  components: {
    ModalC1,
    ModalC2,
    ModalC3,
    ModalC4,
    ModalC5,
    ModalC6,
    ModalC7,
    ModalC8,
    ModalC9,
    ModalC10,
    ModalC11,
    ModalC12
  }
})
export default class EventModal extends Vue {
  //Props
  @Prop() activities!: any;
  @Prop() eventCode!: number;
  @Prop() eventName!: string;
  @Prop({ type: Function }) funcEventExec!: any;

  switchId = '';
  switchDescription: any = '';
  idModal = '';
  activityDescription = '';
  sendNotification = false;

  close() {
    this.funcEventExec();
  }

  setModalData(activity: any) {
    this.switchId = activity.sw;
    this.switchDescription = this.$t(`switchs.${this.switchId}`);
    this.activityDescription = activity.description;
    this.sendNotification = activity.sendNotification;
    this.idModal = activity.aswitch.keyModal;

    this.$bvModal.show(activity.aswitch.keyModal);
  }

  saveProcess(bvModalEvent: any) {
    bvModalEvent.preventDefault();
    // eslint-disable-next-line no-console
    console.log('Exec Function!');
  }
}
